const BASE = '/tableau-de-bord/messagerie'

/** Parse messaging URL segments reliably (avoids useMatch ambiguities). */
export const parseMessagingPath = (pathname) => {
  const postChat = pathname.match(/\/messagerie\/post\/([^/]+)\/chat\/([^/]+)/)
  if (postChat) {
    return { postId: postChat[1], conversationId: postChat[2], artisanId: null }
  }

  const artisanChat = pathname.match(/\/messagerie\/artisan\/([^/]+)\/chat\/([^/]+)/)
  if (artisanChat) {
    return { artisanId: artisanChat[1], conversationId: artisanChat[2], postId: null }
  }

  const flatChat = pathname.match(/\/messagerie\/chat\/([^/]+)/)
  if (flatChat) {
    return { conversationId: flatChat[1], postId: null, artisanId: null }
  }

  const postThreads = pathname.match(/\/messagerie\/post\/([^/]+)$/)
  if (postThreads) {
    return { postId: postThreads[1], conversationId: null, artisanId: null }
  }

  const artisanThreads = pathname.match(/\/messagerie\/artisan\/([^/]+)$/)
  if (artisanThreads) {
    return { artisanId: artisanThreads[1], conversationId: null, postId: null }
  }

  return { postId: null, artisanId: null, conversationId: null }
}

export const messagingPaths = {
  root: () => BASE,

  postThreads: (postId) => `${BASE}/post/${postId}`,

  artisanThreads: (artisanId) => `${BASE}/artisan/${artisanId}`,

  chat: ({ chatId, postId, artisanId }) => {
    if (postId) return `${BASE}/post/${postId}/chat/${chatId}`
    if (artisanId) return `${BASE}/artisan/${artisanId}/chat/${chatId}`
    return `${BASE}/chat/${chatId}`
  },

  group: (group) => {
    if (!group) return BASE
    if (group.kind === 'POST' && group.postId) return `${BASE}/post/${group.postId}`
    if (group.peerUserId) return `${BASE}/artisan/${group.peerUserId}`
    return BASE
  },

  chatFromRecord: (chat, userId) => {
    if (!chat?.id) return BASE
    const postId = chat.postId ?? chat.post?.id
    if (postId) return `${BASE}/post/${postId}/chat/${chat.id}`
    const peer = chat.participants?.find(
      (p) => p.userId !== userId && p.roleInChat !== 'ADMIN'
    )
    if (peer?.userId) return `${BASE}/artisan/${peer.userId}/chat/${chat.id}`
    return `${BASE}/chat/${chat.id}`
  },
}
